import type { AxiosRequestConfig } from "axios"
import type { MaybeRef } from "vue"
import type { ServerResponseV1 } from "@/http"
import type { IAudioAssetResponse } from "@/types"
import { useQuery } from "@tanstack/vue-query"
import { computed, toValue } from "vue"
import { v1 } from "@/axios"
import { AudioAsset } from "@/models"

export async function listSlideshowAudio(eventVaultId: number, search?: string) {
  const endpoint = `/${eventVaultId}/slideshow/audio`

  const options: AxiosRequestConfig = {}

  if (search) {
    options.params = { search }
  }

  const response = await v1.get<ServerResponseV1<IAudioAssetResponse[]>>(endpoint, options)

  return response.data.data?.map(asset => AudioAsset.fromResponse(asset)) ?? []
}

const LIST_SLIDESHOW_AUDIO = "listSlideshowAudio"

export function useListSlideshowAudio(
  eventVaultId?: MaybeRef<number | undefined>,
  search?: MaybeRef<string | undefined>,
  options: { enabled?: MaybeRef<boolean> } = {},
) {
  return useQuery({
    queryKey: [LIST_SLIDESHOW_AUDIO, eventVaultId, search],
    queryFn: () => listSlideshowAudio(toValue(eventVaultId)!, toValue(search)),
    enabled: computed(() => !!toValue(eventVaultId) && (toValue(options.enabled) ?? true)),
    retry: false,
  })
}
